import React from 'react'
import ContactMessages from '../../components/admin/contact-messages/contact-messages'
import AdminTemplate from '../../templates/admin-template'

const AdminContactMessagesPage = () => {
  return (
    <AdminTemplate>
        <ContactMessages/>
    </AdminTemplate>
  )
}

export default AdminContactMessagesPage